import "./src/styles/global.css"
import "./src/styles/prism-tomorrow.css"
import React from "react"
import { UIProvider } from "./src/context/ui-context"

export const wrapRootElement = ({ element }) => (
  <UIProvider>{element}</UIProvider>
)